import React from "react";
import { string, number } from "prop-types";

const EmailIcon = ({ color = "#FFF", width = 21, height = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21 15">
    <path
      fill={color}
      fillRule="nonzero"
      d="M20.517 4.96c.078-.077.163-.09.254-.038s.137.13.137.234v7.969c0 .52-.182.964-.547 1.328a1.808 1.808 0 0 1-1.328.547H2.783c-.52 0-.964-.182-1.328-.547a1.808 1.808 0 0 1-.547-1.328V5.156c0-.104.046-.176.137-.215a.252.252 0 0 1 .254.02c.859.651 2.864 2.122 6.015 4.414l.39.352c.626.468 1.12.807 1.485 1.015.625.339 1.198.508 1.719.508.52 0 1.094-.182 1.719-.547.39-.208.885-.547 1.484-1.016l.39-.312c3.074-2.214 5.079-3.685 6.016-4.414zM10.908 10c-.339 0-.755-.156-1.25-.469-.286-.156-.69-.442-1.211-.86l-.39-.273C4.852 6.055 2.678 4.44 1.532 3.555l-.273-.196a.89.89 0 0 1-.352-.742v-.742c0-.52.182-.964.547-1.328A1.808 1.808 0 0 1 2.783 0h16.25c.52 0 .963.182 1.328.547.365.364.547.807.547 1.328v.742a.89.89 0 0 1-.352.742l-.195.157c-1.12.885-3.32 2.513-6.601 4.882l-.391.274c-.52.417-.925.703-1.211.86-.495.312-.911.468-1.25.468z"
    />
  </svg>
);

EmailIcon.propTypes = {
  color: string,
  width: number,
  height: number
};

export default EmailIcon;
